import { tagInfo, phraseInfo } from "./constants";

const TagButtonList = ({ tagList, onClick }) => {
  const mobile = Math.min(window.innerWidth, window.screen.width) <= 768;
  return (
    <div
      className="syntax-tags"
      style={
        mobile
          ? {
              // [구문분석 모바일 v2] 고정폭 버튼이 흩어져 마지막 버튼이 혼자 붕 뜨던 것 →
              // 균등 그리드: 모든 버튼 같은 폭, 줄 정렬 딱 맞음
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // [v9] 한 줄에 3개 고정
              gap: "8px",
              width: "100%",
              boxSizing: "border-box",
            }
          : {
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "30px",
              flexWrap: "wrap",
              whiteSpace: "pre-wrap",
            }
      }
    >
      {tagList.map((tag) => {
        return (
          <div
            key={tag}
            className="syntax-tag"
            data-tag={tag}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: mobile ? "7px 2px" : "10px",
              width: mobile ? "auto" : "110px",
              fontSize: mobile ? "12px" : "20px",
              fontWeight: mobile ? 600 : undefined,
              borderRadius: mobile ? "8px" : "5px",
              cursor: "pointer",
              backgroundColor: tagInfo[tag]
                ? tagInfo[tag].backgroundColor
                : phraseInfo[tag].backgroundColor,
              border: tagInfo[tag]
                ? "1px solid " + tagInfo[tag].color
                : "1px solid " + phraseInfo[tag].color,
              color: tagInfo[tag] ? tagInfo[tag].color : phraseInfo[tag].color,
            }}
            onClick={() => onClick(tag)}
          >
            {tagInfo[tag] ? tagInfo[tag].tagText : phraseInfo[tag].tagText}
          </div>
        );
      })}
    </div>
  );
};

export default TagButtonList;
